// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMessagePanel_root__bpmoD {
  border-top: 1px solid #E5E6EE;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.NewMessagePanel_main__b4lD\\+ {
  display: flex;
  align-items: flex-end;
}
.NewMessagePanel_main__b4lD\\+ .NewMessagePanel_textField__Me7hJ {
  flex-grow: 1;
  line-height: 0;
}
.NewMessagePanel_main__b4lD\\+ > * {
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ui/ChatBottomPanels/NewMessagePanel/NewMessagePanel.module.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;AACF;AACE;EACE,YAAA;EACA,cAAA;AACJ;AAEE;EACE,cAAA;AAAJ","sourcesContent":[".root {\n  border-top: 1px solid #E5E6EE;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.main {\n  display: flex;\n  align-items: flex-end;\n\n  .textField {\n    flex-grow: 1;\n    line-height: 0;\n  }\n\n  &>* {\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NewMessagePanel_root__bpmoD`,
	"main": `NewMessagePanel_main__b4lD+`,
	"textField": `NewMessagePanel_textField__Me7hJ`
};
export default ___CSS_LOADER_EXPORT___;
